import { useState, useEffect, useContext } from "react";
import NumberFormat from "react-number-format";
import { Link, useNavigate } from "react-router-dom";

import { Card, Badge } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiAvatar from "components/SuiAvatar";
import SuiButton from "components/SuiButton";

import IconButton from "@mui/material/IconButton";
import api from "services/api";

import toast from "react-hot-toast";

import CategoryContext from "context/category-context";
import { AccountContext } from "context/account";
import { StoreContext } from "context/store";

import { stylesSortOptions } from "utils/data";
import { compare } from "utils/helper";

import StyleThumbnail from "pages/de/share-page/components/StyleThumbnail";
import ShareListModal from "pages/de/share-page/components/ShareListModal";
import SharedUserList2 from "pages/de/share-page/components/SharedUserList2";
import CollaboratorsListModal from "pages/de/dashboard/components/CollaboratorsListModal";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CollectionsIcon from "@mui/icons-material/Collections";
import StyleIcon from "@mui/icons-material/Style";
import PaletteIcon from "@mui/icons-material/Palette";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import PhotoAlbumIcon from "@mui/icons-material/PhotoAlbum";

import moment from "moment";

import { MAX_SCREEN_WIDTH } from "utils/data";

const CollaboratorsBar = ({ moodboardCount, collectionCount, styleCount, projectCount }) => {
  const [shareVisible, setShareVisible] = useState(false);
  const [permittedUsers, setPermittedUsers] = useState([]);
  const [userListVisible, setUserListVisible] = useState(false);

  const navigate = useNavigate();
  const account = useContext(AccountContext);
  const { store } = useContext(StoreContext);

  useEffect(() => {
    handleRefresh();
  }, []);

  const retrieveUsersWithPermission = async () => {
    try {
      const payload = {
        order: ["-updated_at"],
        //resource_type: "product",
      };

      const rp = await api.resourcePermission.sharingList(payload);
      let userList = rp?.data?.resource_permissions || [];
      let idSet = new Set();
      let filteredList = [];
      for (let i = 0; i < userList.length; i++) {
        if (
          idSet.has(userList[i].user_id) ||
          !userList[i].user ||
          userList[i].user_id == account.id
        ) {
          //
        } else {
          idSet.add(userList[i].user_id);
          filteredList.push(userList[i]);
        }
      }

      setPermittedUsers(filteredList || []);
    } catch (err) {
      console.log(err);
      toast.error("Retrieve user access list failed!");
    }
  };
  const handleRefresh = () => {
    retrieveUsersWithPermission();
  };

  const handleAdditionalAvatarClick = (e) => {
    setUserListVisible(true);
  };

  const handleCloseMenu = () => {
    setUserListVisible(false);
  };

  const handleAvatarClick = (user) => {
    console.log(user);
    const userData = user?.user;
    navigate(`/wall/portfolio/${userData.id}`);
  };

  const handleAddMoodboard = async () => {
    try {
      let payload = {
        name: "Untitled",
      };

      //create moodboard
      const newMoodboard = await api.moodboard.create(payload);
      const moodboard_id = newMoodboard?.data?.id;

      toast.success(`Your Moodboard has been successfully created!`);
      navigate(`/workspace/moodboard?id=${moodboard_id}`);
    } catch (err) {
      toast.error(`Your Moodboard could not be created!`);
      console.log(err);
    }
  };

  const handleCreateCollection = async () => {
    try {
      const currentYear = moment().format("YYYY");
      const brandName = store?.name;
      //edit collection
      let payload = {
        title: "Untitled",
        description: undefined,
        metadata: {
          year: currentYear,
          season: undefined,
          //tags: collectionTags,
          brand: brandName,
        },
      };

      let { data } = await api.collections.create(payload);

      toast.success(`Your Collection has been successfully created!`);
      if (data?.collection?.id) {
        navigate(`/workspace/collections?id=${data?.collection?.id}`);
      }
    } catch (err) {
      console.log(err);
      if (err?.response?.status == 401) {
        return toast.error(err?.response?.data?.error || err?.response?.statusText);
      }
      toast.error(`Your Collection could not be created !`);
    }
  };

  return (
    <div style={{ marginBottom: "60px" }}>
      <SuiBox
        sx={{
          position: "fixed",
          top: 60,
          mb: 60,
          left: 0,
          height: 50,
          width: "100%",
          zIndex: 3,
        }}
      >
        <SuiBox
          shadow="md"
          sx={({ palette: { transparent: transparentColor, white }, functions: { rgba } }) => ({
            backgroundColor: rgba(white.main, 0.65),
            backdropFilter: `saturate(200%) blur(30px)`,
            borderRadius: 0,
            height: 50,
            position: "relative",
            width: "100%",
            px: 4,
            margin: "0px auto",
          })}
        >
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ height: "100%" }}
          >
            {/* <SuiBox
              display={{ xs: "none", sm: "flex" }}
              alignItems="center"
              justifyContent="flex-start"
              gap={2}
              sx={{ height: "100%" }}
            >
              <SuiBox display="flex" alignItems="center" justifyContent="flex-start">
                <Tooltip title="Moodboards">
                  <div>
                    <SuiTypography
                      color="navyBlue"
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        fontSize: 14,
                        display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      component={Link}
                      to={`/workspace/moodboard`}
                    >
                      <PaletteIcon sx={{ height: 18, width: 18 }} />
                      Moodboards
                    </SuiTypography>

                    <SuiBox sx={{ display: { md: "block", lg: "none" } }}>
                      <IconButton
                        sx={{
                          "&:hover": { backgroundColor: (theme) => theme.palette.grey[200] },
                        }}
                        component={Link}
                        to={`/workspace/moodboard`}
                      >
                        <PaletteIcon />
                      </IconButton>
                    </SuiBox>
                  </div>
                </Tooltip>

                <SuiTypography
                  color="navyBlue"
                  variant="body1"
                  fontWeight="bold"
                  sx={{
                    fontSize: 14,
                    display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  (<Link to={`/workspace/moodboard`}>{moodboardCount}</Link> )
                </SuiTypography>
              </SuiBox>

              <SuiBox display="flex" alignItems="center" justifyContent="flex-start">
                <Tooltip title="Create collection">
                  <div>
                    <SuiTypography
                      color="navyBlue"
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        fontSize: 14,
                        display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      component={Link}
                      to={`/workspace/collections`}
                    >
                      <CollectionsIcon sx={{ height: 18, width: 18 }} />
                      Collections
                    </SuiTypography>

                    <SuiBox sx={{ display: { md: "block", lg: "none" } }}>
                      <IconButton
                        sx={{
                          "&:hover": { backgroundColor: (theme) => theme.palette.grey[200] },
                        }}
                        component={Link}
                        to={`/workspace/collections`}
                      >
                        <CollectionsIcon />
                      </IconButton>
                    </SuiBox>
                  </div>
                </Tooltip>

                <SuiTypography
                  color="navyBlue"
                  variant="body1"
                  fontWeight="bold"
                  sx={{
                    fontSize: 14,
                    display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  (<Link to={`/workspace/collections`}>{collectionCount}</Link> )
                </SuiTypography>
              </SuiBox>

              <SuiBox display="flex" alignItems="center" justifyContent="flex-start">
                <Tooltip title="Create style">
                  <div>
                    <SuiTypography
                      color="navyBlue"
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        fontSize: 14,
                        display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      to={`/workspace/styles-master`}
                      component={Link}
                    >
                      <StyleIcon sx={{ height: 18, width: 18 }} />
                      Styles
                    </SuiTypography>

                    <SuiBox sx={{ display: { md: "block", lg: "none" } }}>
                      <IconButton
                        sx={{
                          "&:hover": { backgroundColor: (theme) => theme.palette.grey[200] },
                        }}
                        component={Link}
                        to={`/workspace/styles-master`}
                      >
                        <StyleIcon />
                      </IconButton>
                    </SuiBox>
                  </div>
                </Tooltip>

                <SuiTypography
                  color="navyBlue"
                  variant="body1"
                  fontWeight="bold"
                  sx={{
                    fontSize: 14,
                    display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  (<Link to={`/workspace/styles-master`}>{styleCount}</Link> )
                </SuiTypography>
              </SuiBox>

              <SuiBox display="flex" alignItems="center" justifyContent="flex-start">
                <Tooltip title="Create development project">
                  <div>
                    <SuiTypography
                      color="navyBlue"
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        fontSize: 14,
                        display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      to={`/produce/all-projects`}
                      component={Link}
                    >
                      <NoteAddIcon sx={{ height: 18, width: 18 }} />
                      Projects
                    </SuiTypography>

                    <SuiBox sx={{ display: { md: "block", lg: "none" } }}>
                      <IconButton
                        sx={{
                          "&:hover": { backgroundColor: (theme) => theme.palette.grey[200] },
                        }}
                        to={`/produce/all-projects`}
                        component={Link}
                      >
                        <NoteAddIcon />
                      </IconButton>
                    </SuiBox>
                  </div>
                </Tooltip>

                <SuiTypography
                  color="navyBlue"
                  variant="body1"
                  fontWeight="bold"
                  sx={{
                    fontSize: 14,
                    display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  (<Link to={`/produce/all-projects`}>{projectCount}</Link> )
                </SuiTypography>
              </SuiBox>

              <Tooltip title="Edit tech pack">
                <Link to={`/workspace/tech-packs`}>
                  <div>
                    <SuiTypography
                      color="navyBlue"
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        fontSize: 14,
                        display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                        alignItems: "center",
                      }}
                    >
                      <DesignServicesIcon sx={{ height: 18, width: 18 }} />
                      Tech Pack
                    </SuiTypography>
                    <SuiBox sx={{ display: { md: "block", lg: "none" } }}>
                      <IconButton
                        sx={{
                          "&:hover": { backgroundColor: (theme) => theme.palette.grey[200] },
                        }}
                      >
                        <DesignServicesIcon />
                      </IconButton>
                    </SuiBox>
                  </div>
                </Link>
              </Tooltip>
              <Tooltip title="Edit my portfolio">
                <Link to={`/wall/portfolio`}>
                  <div>
                    <SuiTypography
                      color="navyBlue"
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        fontSize: 14,
                        display: { xs: "none", sm: "none", md: "none", lg: "flex" },
                        alignItems: "center",
                      }}
                    >
                      <PhotoAlbumIcon sx={{ height: 18, width: 18 }} />
                      Portfolio
                    </SuiTypography>
                    <SuiBox sx={{ display: { md: "block", lg: "none" } }}>
                      <IconButton
                        sx={{
                          "&:hover": { backgroundColor: (theme) => theme.palette.grey[200] },
                        }}
                      >
                        <PhotoAlbumIcon />
                      </IconButton>
                    </SuiBox>
                  </div>
                </Link>
              </Tooltip>
            </SuiBox> */}

            {permittedUsers && permittedUsers.length > 0 ? (
              <SuiBox
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                gap={0.5}
                sx={{ height: "100%" }}
              >
                <SuiTypography variant="h6" textTransform="capitalize">
                  Collaborators:
                </SuiTypography>
                <SharedUserList2
                  collaboratorUsers={permittedUsers}
                  size="md"
                  onAvatarClick={(e, user) => handleAvatarClick(user)}
                  isOwner
                  ownerStore={account}
                  handleAdditionalAvatarClick={handleAdditionalAvatarClick}
                  maxAvatar={6}
                />
              </SuiBox>
            ) : null}
          </SuiBox>
        </SuiBox>
        {userListVisible ? (
          <CollaboratorsListModal
            visible={userListVisible}
            handleClose={() => setUserListVisible(false)}
            permittedUsers={permittedUsers}
            onAvatarClick={(e, user) => handleAvatarClick(user)}
          />
        ) : null}
      </SuiBox>
    </div>
  );
};

export default CollaboratorsBar;
